import { resolveStoredFileUrl } from "utils/storedFileUrl";
// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import {
  Card,
  CircularProgress,
  Fade,
  Grid,
  Icon,
  Input,
  InputLabel,
  Modal,
  Tooltip,
} from "@mui/material";

import { gql, useMutation } from "@apollo/client";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "95%",
  width: { xs: "80%", sm: "70%", xxl: "70%" },
  overflowY: "auto",
  p: 3,
};

const allowedFileTypes = ".jpg,.jpeg,.png,.gif,.bmp";

export default function ModalArea({ open, handleClose, refetchAreas, selectedArea, onAreaSaved }) {
  const { handleSnackbar } = useContext(MessageManager);

  const [area, setArea] = useState({ nombre: "", orden: "" });
  const [file, setFile] = useState(null);
  const [keyFile, setKeyFile] = useState(0);
  const [saveArea, { loading }] = useMutation(
    gql`
      mutation saveArea($input: AreaInput!) {
        saveArea(input: $input) {
          id
        }
      }
    `
  );
  const handleChangeArea = (e) => {
    setArea({ ...area, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (area.orden && isIntegerToString(area.orden)) {
      handleSnackbar("El campo orden debe ser un número entero positivo", "error");
      return;
    }
    let inputSave =
      !file && area.file
        ? {
            id: selectedArea ? selectedArea.id : null,
            nombre: area.nombre,
            orden: Number(area.orden) || null,
          }
        : {
            id: selectedArea ? selectedArea.id : null,
            nombre: area.nombre,
            orden: Number(area.orden) || null,
            file: file || null,
          };
    saveArea({
      variables: {
        input: {
          ...inputSave,
        },
      },
    })
      .then(({ data: saveAreaData }) => {
        const savedAreaId = saveAreaData?.saveArea?.id || selectedArea?.id || null;
        onAreaSaved?.(savedAreaId);
        handleSnackbar("Guardado correctamente", "success");
        refetchAreas();
        handleClose();
        handleRemoveFile();
      })
      .catch(() => {
        handleSnackbar("Error al guardar", "error");
      });
  };

  useEffect(() => {
    if (!open) {
      setArea({ nombre: "", orden: "" });
      handleRemoveFile();
    } else {
      if (selectedArea) {
        setArea(selectedArea);
      } else {
        setArea({ nombre: "", orden: "" });
      }
    }
  }, [open, selectedArea]);
  //Lógica archivos imágen
  const toggleInput = () => {
    document.getElementById("input-file").click();
  };
  const handleRemoveFile = () => {
    setKeyFile((prev) => prev + 1);
    setFile(null);
    setArea({ ...area, file: null });
  };
  const handleFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
    }
  };
  //Validación de campos
  const isIntegerToString = (str) => {
    const num = Number(str);
    return !(!isNaN(num) && Number.isInteger(num) && num > 0);
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <Grid container spacing={1}>
            <Grid item xs={12} display="flex" flexDirection="row" justifyContent="space-between">
              <Grid></Grid>
              <SoftTypography variant="h6" align="center">
                Area / Sector
              </SoftTypography>
              <Grid>
                <Tooltip title="Cerrar" placement="top">
                  <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                    close
                  </Icon>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid item xs={9}>
              <InputLabel htmlFor="precioCarta">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Nombre
                </SoftTypography>
              </InputLabel>
              <SoftInput
                placeholder="Ej: (Entrada, Patio, Primer piso, etc)"
                label="Nombre"
                name="nombre"
                value={area.nombre}
                onChange={handleChangeArea}
              />
            </Grid>
            <Grid item xs={3}>
              <InputLabel htmlFor="precioCarta">
                <SoftTypography component="label" variant="caption" fontWeight="bold" error={true}>
                  Orden
                </SoftTypography>
              </InputLabel>
              <SoftInput
                placeholder="Ej: (1,2,3)"
                label="Orden"
                name="orden"
                value={area.orden}
                onChange={handleChangeArea}
                error={isIntegerToString(area.orden) && area.orden}
              />
            </Grid>
            <Grid item xs={12} container>
              <InputLabel htmlFor="imagen">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Imágen
                </SoftTypography>
                {(file || area.file) && (
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    color="primary"
                    sx={{ cursor: "pointer" }}
                    onClick={handleRemoveFile}
                  >
                    &nbsp; - Quitar imágen <Icon>cancel</Icon>
                  </SoftTypography>
                )}
              </InputLabel>
              {file || area.file ? (
                <Grid itm xs={12} display="flex" justifyContent="center">
                  <Grid display="flex" justifyContent="center" alignItems="center">
                    <img
                      src={file ? URL.createObjectURL(file) : resolveStoredFileUrl(area.file)}
                      alt="imagen"
                      style={{ objectFit: "cover", width: "180px" }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                  alignItems="center"
                >
                  <SoftTypography variant="caption" color="text" mb={1}>
                    No hay imagen seleccionada
                  </SoftTypography>
                  <SoftButton color="dark" circular onClick={toggleInput}>
                    <Icon>add_a_photo</Icon>
                    &nbsp;Agregar
                  </SoftButton>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              display="flex"
              justifyContent="flex-end"
              flexDirection={{
                xs: "column",
                sm: "row",
              }}
            >
              <SoftButton
                color="primary"
                circular
                onClick={() => {
                  handleClose();
                  handleRemoveFile();
                }}
                disabled={loading}
                sx={{
                  marginRight: {
                    xs: 0,
                    sm: 1,
                  },
                  marginBottom: { xs: 1, sm: 0 },
                }}
              >
                {false ? (
                  <CircularProgress size={15} color="inherit" />
                ) : (
                  <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                )}
                &nbsp;Cancelar
              </SoftButton>
              <SoftButton color="uproGreen" circular onClick={handleSave} disabled={loading}>
                {false ? (
                  <CircularProgress size={15} color="inherit" />
                ) : (
                  <Icon sx={{ fontWeight: "light" }}>save</Icon>
                )}
                &nbsp;Guardar
              </SoftButton>
            </Grid>
          </Grid>
          <Grid sx={{ display: "none" }}>
            <Input
              type="file"
              id="input-file"
              onChange={handleFile}
              name="recibos"
              inputProps={{ accept: allowedFileTypes, multiple: false }}
              key={keyFile}
            />
          </Grid>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalArea.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetchAreas: PropTypes.func,
  selectedArea: PropTypes.object,
  onAreaSaved: PropTypes.func,
};
